import React, {Fragment, useContext} from 'react';
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import TextField from '@material-ui/core/TextField';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from "@material-ui/pickers";
import {InvitesContext} from "../context/InvitesContext";
import {handleChangeFactory} from "../utils/EventHandlerUtils";


export default function ChurchDetails(props) {
    const { classes } = props;
    const invitesContext = useContext(InvitesContext);
    const handleChange = handleChangeFactory(invitesContext.dispatch);

    const handleChurchStartTime = (date) => {
        invitesContext.dispatch({ type: "CHANGE_VALUE", name: "churchStartTime", value: date });
        invitesContext.dispatch({ type: "CHANGE_VALUE", name: "churchStartTimeTimestamp", value:  Math.round(date.getTime()/1000) });
    }

    return (
        <Fragment>
            <Grid container spacing={2} noValidate className={classes.inputContainer}>
                <Grid item xs={12} className={classes.noPadding}>
                    <Paper square elevation={0} className={classes.inputTitleContainer}>
                        <Typography className={classes.inputTitleText}>Biserica *</Typography>
                    </Paper>
                    <TextField
                        fullWidth
                        margin="normal"
                        className={classes.inputFieldContainer}
                        name="churchName"
                        placeholder="Ex: Sfantul Spiridon Nou"
                        onChange={handleChange}
                        defaultValue={invitesContext.state.invite.churchName}
                    />
                </Grid>
                <Grid container className={classes.wrapFields}>
                    <Grid item xs={6} sm={6} className={classes.noPadding}>
                        <Paper square elevation={0} className={classes.inputTitleContainer}>
                            <Typography className={classes.inputTitleText}>Adresa</Typography>
                        </Paper>
                        <TextField
                            fullWidth
                            className={classes.inputFieldContainer}
                            name="churchAddress"
                            placeholder="Ex. Calea Șerban Vodă 29, București"
                            onChange={handleChange}
                            defaultValue={invitesContext.state.invite.churchAddress}
                        />
                    </Grid>
                    <Grid item xs={4} sm={4} className={classes.noPadding}>
                        <Paper square elevation={0} className={classes.inputTitleContainer}>
                            <Typography className={classes.inputTitleText}>Ora *</Typography>
                        </Paper>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardTimePicker
                                fullWidth
                                margin="normal"
                                className={classes.inputChurchFieldContainer}
                                ampm={false}
                                format="HH:mm"
                                value={invitesContext.state.invite.churchStartTime}
                                onChange={handleChurchStartTime}
                                name="churchStartTime"
                                cancelLabel="Anuleaza"
                                InputProps={{ readOnly: true }}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                </Grid>
            </Grid>
        </Fragment>
    )
}